import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

export const useExportConfirmOrders = () => {
  const mutate = useMutation(
    ({
      warehouseOrderIds,
      principle,
    }: {
      warehouseOrderIds: any[]
      principle: any
    }) => {
      const confirmOrders = warehouseOrderIds.map((order: any) => ({
        principle: principle || '',
        orderNo: order.orderNo || '',
        consNo: order.consNo || '',
        noOfSkus: order.partnerOrder.partnerOrderLines.length || 0,
        orderType: order.partnerOrder.orderType || '',
        rddFrom: order.partnerOrder.dateWanted || undefined,
        rddTo: order.partnerOrder.despatchBefore || undefined,
        defaultCarrierName: order.partnerOrder?.defaultCarrierName || '',
        carrierServiceProduct: order.partnerOrder?.carrierProduct || '',
        destination: order.partnerOrder.shippingAddress.countryCode || '',
        length: order.shipments[0].packages[0].length || 0,
        width: order.shipments[0].packages[0].width || 0,
        height: order.shipments[0].packages[0].height || 0,
        weight: order.shipments[0].packages[0].weight || 0,
      }))

      return postAPI(`PWBulkConsignment/ExportConfirmOrders`, { confirmOrders })
    },
  )

  return mutate
}

export default useExportConfirmOrders
